import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    currentVersion: '',
    latestVersion: '',
    hasUpdate: false,
    showUpdateBanner: false,
    isDismissed: false,
    dismissedVersion: '', // Track which version was dismissed
    updateInfo: null,
    lastChecked: null,
    // New fields for API version management
    apiVersion: process.env.REACT_APP_VERSION || '1.0.0', // Fallback version
    versionSource: 'env', // 'api' or 'env'
    isLoading: false,
    error: null
};

const versionSlice = createSlice({
    name: 'version',
    initialState,
    reducers: {
        setVersionInfo: (state, action) => {
            const { currentVersion, latestVersion, hasUpdate, updateInfo } = action.payload;
            state.currentVersion = currentVersion;
            state.latestVersion = latestVersion;
            state.hasUpdate = hasUpdate;
            state.updateInfo = updateInfo;
            state.lastChecked = new Date().toISOString();
            // Only show banner if not dismissed for this specific version
            state.showUpdateBanner = hasUpdate && !state.isDismissed && state.dismissedVersion !== latestVersion;
        },
        dismissUpdateBanner: (state) => {
            state.isDismissed = true;
            state.dismissedVersion = state.latestVersion; // Remember which version was dismissed
            state.showUpdateBanner = false;
        },
        resetVersionState: (state) => {
            Object.assign(state, initialState);
        },
        // New reducers for API version management
        setApiVersion: (state, action) => {
            const { version, source } = action.payload;
            state.apiVersion = version;
            state.versionSource = source;
            state.error = null;
        },
        setVersionLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setVersionError: (state, action) => {
            state.error = action.payload;
            state.versionSource = 'env'; // Fallback to env on error
        }
    },
});

export const { 
    setVersionInfo, 
    dismissUpdateBanner, 
    resetVersionState,
    setApiVersion,
    setVersionLoading,
    setVersionError
} = versionSlice.actions;
export default versionSlice.reducer;
